import { parseEnum } from '@shared/utils/parse-enum';

import type { RoleDto } from '../dto';
import { UserRole, type Role } from '../models';

export function mapRoleFromDto(dto: RoleDto): Role {
  return {
    id: dto.id,
    key: parseEnum(dto.key, UserRole),
    name: dto.name,
  };
}
